import React from 'react';
import Helpers from "../../../../dev/helpers/helperFunctions";
import Config from "../../../config/main";
import {t} from "../../../../dev/helpers/translator";

export default function languageSwitcherTemplate () {
    let { isOpenedLanguages, isOpenedSettingSportsBook } = this.props;
    let rules = Config.termsAndConditionPDFLoad ? "termsAndConditions" : "rules"
    return (
        <div className="mini-naw-contain">
            <ul>
                {
                    Config.disableLanguages ? null : <li>
                        <div className={`single-nav-item ${isOpenedLanguages && "active"}`} onClick={this.setHandleClick("openLanguages")}>
                            <p className="flag-wrapper-h">
                                {Helpers.objectToArray(Config.main.availableLanguages, "code").sort(Helpers.byOrderSortingFunc).map(lng => {
                                    return lng.region && lng.code === this.props.preferences.lang && <span key={lng.region} className={"flag-view-m icon-" + lng.region.toLowerCase().replace(/\s/g, '')}/>;
                                })}
                            </p>
                            <div className="open-d-view">
                                <ul>
                                    {Helpers.objectToArray(Config.main.availableLanguages, "code").sort(Helpers.byOrderSortingFunc).map(
                                        lng => {
                                            return lng["region"] !== undefined && lng.code !== this.props.preferences.lang &&
                                                <li key={lng.code} onClick={this.changeLanguageTo(lng.code)}>
                                                    <div className={"flag-view-m icon-" + (lng.region && lng.region.toLowerCase().replace(/\s/g, ''))}/>
                                                </li>;
                                        }
                                    )}
                                </ul>
                            </div>
                        </div>
                    </li>

                }
                {
                    Config.main.showSportsbookInterfaceSettings && <li onClick={this.setHandleClick("settingSportsbook")}>
                        <div className={`single-nav-item ${isOpenedSettingSportsBook && "active"}`}>
                            <p>
                                <i className="settings-ico-v"/>
                            </p>
                            <div className="open-d-view">
                                <ul>
                                    <li className="interface-head"><h1>{t("Sportsbook interface")}</h1></li>
                                    {
                                        Config.terminal.sportsbookSettingsTypes.map((type, i) => {
                                            return <li key={i} className={`switcher-v ${this.state.activeSetting === i && "active"}`} onClick={this.changeSportsbookLayout(type, i)}>{type}</li>;
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </li>
                }
                <li>
                    <div className="single-nav-item" onClick={this.props.openPopup(rules)}>
                        <p>
                            <i className="help-ico-v"/>
                        </p>
                    </div>
                </li>

                {
                    !this.props.user.loggedIn && <li>
                        <button className="button-view-t" onClick={this.props.openPopup("LoginForm", {signInToAdmin: Config.terminal.signInToAdmin})}>{t(Config.terminal.signInToAdmin ? "Admin" : "SIGN IN")}</button>
                    </li>
                }
            </ul>
        </div>
    );
};
